import React from 'react';
import { Link } from 'react-router-dom';
import BlogByline from '../components/BlogByline.jsx';
import { getAllDevBlogs } from '../lib/featured.js';

export default function Blog() {
  const posts = getAllDevBlogs();

  return (
    <>
      <h2 className="page-header">Blog</h2>
      <section className="blog-index">
        <p>
          Development notes connected to featured works, newest first.
        </p>

      {posts.length === 0 ? (
        <p className="gallery-hint">Posts will appear here when a featured work has a connected dev blog.</p>
      ) : (
        <ul className="blog-index-list">
          {posts.map((post) => {
            const isImage = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(post.thumbnailExt);
            const isVideo = ['mp4', 'webm'].includes(post.thumbnailExt);
            const hasThumb = Boolean(post.thumbnailUrl) && (isImage || isVideo);

            return (
              <li key={post.to}>
                <Link
                  to={post.to}
                  className={`blog-index-card${hasThumb ? ' has-media' : ''}`}
                >
                  {hasThumb && (
                    <div className="blog-index-media" aria-hidden="true">
                      {isImage && (
                        <img className="pixelated" src={post.thumbnailUrl} alt="" />
                      )}
                      {isVideo && (
                        <video className="pixelated" src={post.thumbnailUrl} muted playsInline />
                      )}
                    </div>
                  )}
                  <div className="blog-index-body">
                    <p className="blog-index-category">{post.categoryLabel}</p>
                    <h3>{post.title}</h3>
                    <BlogByline date={post.date} author={post.author} />
                    {post.excerpt && <p className="blog-index-excerpt">{post.excerpt}</p>}
                    <span className="blog-index-read">Read post</span>
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
      </section>
    </>
  );
}
